import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-core-theme/src/hooks/link';
import { getUrl } from 'gatsby-core-theme/src/helpers/getters';

const Card = ({ item }) => (
  <Link to={item.path} className="archive-gtm item-gtm">
    {getUrl(item.path)}
  </Link>
);

Card.propTypes = {
  item: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export default Card;
